import { useLocation } from 'react-router-dom';

export const useActiveLink = (link: string, deep?: boolean) => {
  const { pathname } = useLocation();
  const checkIsActive = () => {
    return pathname.startsWith(link);
  };
  return { active: checkIsActive() };
};
